export enum InvoiceActivityStatus {
  Invoiced = 'invoiced',
  NotInvoiced = 'notInvoiced',
}
